import { TextareaAutosize } from "@material-ui/core"
import HelpIconWithModal from "components/custom/helpIconWithModal"
import ChatGPTIconWithModal from "components/custom/chatGPTIconWithModal"
import React, { useEffect } from "react"
import { Col, Input, Label, Row } from "reactstrap"
import { userService } from "services/user.service"
import moment from "moment"
import DynamicForm from "components/custom/DynamicForm/View/DynamicForm"
import useFetcher from "hooks/useFetcher"
import api from "services/api.service"
import isNullOrEmpty from "utils/isNullOrEmpty"
import AlternativeConfigFieldViewOnly from "./AlternativeConfigFieldViewOnly"
import DynamicFormViewOnly from "components/custom/DynamicForm/View/ViewOnly/DynamicFormViewOnly"

const GeneralNeedSectionViewOnly = ({
  alternative,
  governanceOptions,
  sponsoringOptions,
  priorityOptions,
  fieldConfigItems,
  entities,
  formId,
  sbuLabel,
  governanceBoardLabel,
  enterprise,
}) => {
  const currentUser = userService.getLoggedInUser()

  return (
    <React.Fragment>
      {formId != undefined && formId != null && formId > 0 && (
        <DynamicFormViewOnly
          formId={formId}
          itemId={alternative?.alternativeID}
          scenarioId={alternative?.scenarioID}
        />
      )}
      {(!formId || formId <= 0) && (
        <>
          <Row className="mb-3">
            <Col sm="6">
              <div>
                <Label
                  className="form-label"
                  hidden={alternative.alternativeID <= 0}
                >
                  ID
                </Label>
                <p>{alternative.alternativeNum}</p>
              </div>
            </Col>
            <Col
              sm="6"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Label className="form-label">
                <b>
                  Submitted by{" "}
                  {alternative.alternativeID > 0
                    ? alternative.submitter +
                      " - " +
                      moment(alternative.createdDT).format("MM/DD/YYYY")
                    : `${currentUser.firstName} ${currentUser.lastName}`}
                </b>
              </Label>
            </Col>
          </Row>
          <Row>
            <Col sm="6">
              <AlternativeConfigFieldViewOnly
                label={governanceBoardLabel}
                value={alternative.governanceBoardID}
                fieldConfigItems={fieldConfigItems}
                options={governanceOptions}
                prop={"governanceBoardID"}
                type="select"
              />

              <AlternativeConfigFieldViewOnly
                label={
                  isNullOrEmpty(enterprise?.businessPriorityLabel)
                    ? "Business Priority"
                    : enterprise.businessPriorityLabel
                }
                value={alternative.businessPriority}
                fieldConfigItems={fieldConfigItems}
                options={priorityOptions}
                prop={"businessPriority"}
                type="select"
              />
            </Col>
            <Col sm="6">
              <AlternativeConfigFieldViewOnly
                label={sbuLabel}
                value={alternative.sponsoringUnitID}
                fieldConfigItems={fieldConfigItems}
                options={sponsoringOptions}
                prop={"sponsoringUnitID"}
                type="select"
              />
              {entities != null && entities.length > 0 && (
                <div className="mb-3">
                  <Label className="form-label">
                    {entities[0].entityType} *
                  </Label>
                  <p>
                    {
                      entities.find(x => x.entityID == alternative.entityID)
                        ?.entityName
                    }
                  </p>
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <div className="mb-3">
                <Label className="form-label">Title *</Label>
                <p>{alternative.alternativeName}</p>
              </div>
              <div className="mb-3">
                <Label className="form-label">Description *</Label>
                <p>{alternative.description}</p>
              </div>
              <div className="mb-3">
                <Label className="form-label">Customer</Label>
                <p>{alternative.customer}</p>
              </div>
              <div className="mb-3">
                <Label className="form-label">
                  {isNullOrEmpty(enterprise?.businessProblemLabel)
                    ? "Business Problem"
                    : enterprise.businessProblemLabel}
                </Label>
                <p>{alternative.businessProblem}</p>
              </div>
              <div className="mb-3">
                <Label className="form-label">
                  {isNullOrEmpty(enterprise?.businessRequirementsLabel)
                    ? "Business Requirements"
                    : enterprise.businessRequirementsLabel}
                </Label>
                <p>{alternative.businessRequirements}</p>
              </div>
              <div className="mb-3">
                <Label className="form-label">
                  {isNullOrEmpty(enterprise?.businessOutcomesLabel)
                    ? "Business Outcomes"
                    : enterprise.businessOutcomesLabel}
                </Label>
                <p>{alternative.businessOutcomes}</p>
              </div>

              <div className="mb-3">
                <Label className="form-label">
                  {isNullOrEmpty(enterprise?.businessValueLabel)
                    ? "Business Value"
                    : enterprise.businessValueLabel}
                </Label>
                <p>{alternative.businessValue}</p>
              </div>

              <div className="mb-3">
                <Label className="form-label">
                  {isNullOrEmpty(enterprise?.businessRiskLabel)
                    ? "Business Risk"
                    : enterprise?.businessRiskLabel}
                </Label>
                <p>{alternative.businessRisk}</p>
              </div>
              <div className="mb-3">
                <Label className="form-label">Strategic Rationale</Label>
                <p>{alternative.strategicRationale}</p>
              </div>
            </Col>
          </Row>
        </>
      )}
    </React.Fragment>
  )
}

export default GeneralNeedSectionViewOnly
